<template>
  <wsp-modal>
    <v-card class="pb-5"
            flat>
      <v-card-title class="pa-0">
        <v-toolbar class="primary"
                   dark
                   dense
                   flat>
          <v-toolbar-title v-html="$t('buy.coupon.title')">
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon
                 @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-form ref="formCoupon"
                v-model="validCoupon"
                v-on:submit.prevent="()=> {return false}">
          <v-layout row
                    wrap
                    class="pa-3 align-center justify-space-around">
            <v-flex xs12
                    sm9>

              <v-text-field :label="$t('buy.placeholder.coupon')"
                            v-model="couponCode"
                            name="couponCode"
                            :rules='mandatoryRules'></v-text-field>

            </v-flex>
            <v-flex xs12
                    sm2>
              <v-btn :disabled='!validCoupon'
                     :loading="isLoadingCoupon"
                     block
                     outline
                     round
                     color="accent"
                     type="submit"
                     class="capitalize white--text"
                     @click="propagateCoupon">
                {{$t('global.button.apply')}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';

export default {
  name: 'Coupon',
  components: {
    [WspModal.name]: WspModal
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  computed: {
    mandatoryRules() {
      return [v => !!v || this.$i18n.t('global.validation.required.text')]
    }
  },
  data() {
    return {
      isLoadingCoupon: false,
      validCoupon: false,
      visible: true,
      couponCode: null
    };
  },
  methods: {
    propagateCoupon() {
      this.$emit('on-submit', {cupon: this.couponCode});
    }
  }
};
</script>
